<div class="flex justify-content-center align-items-center min-h-screen surface-ground p-4">
    <div class="surface-card p-4 shadow-2 border-round w-full lg:w-4 md:w-6">
        <div class="text-center mb-5">
            <div class="flex align-items-center justify-content-center mb-4">
                <img [src]="'assets/layout/images/logo-dark.png'" style="width: 34px;" class="exception-logo"/>
                <img [src]="'assets/layout/images/appname-dark.png'" style="width: 150px;" class="exception-appname ml-3"/>
            </div>
            <div class="text-900 text-xl font-medium mb-3">Organization Invite</div>
        </div>

        @if(isLoading){
            <!-- Loading State -->
            <div class="text-center py-5">
                <span class="text-700">Processing your invite, please wait...</span>
            </div>
        }

        @if(acceptResult){
            <!-- Result State -->
            <div class="result-section">
                <div class="flex flex-column align-items-center mb-4">
                    <div class="border-circle bg-green-100 flex align-items-center justify-content-center" style="width: 3rem; height: 3rem">
                        <i class="pi pi-check text-green-500 text-2xl"></i>
                    </div>
                    <span class="text-900 font-bold text-xl mt-3">Invite Accepted!</span>
                    <p class="text-600 mt-2">Welcome to the organization.</p>
                </div>

                @if(acceptResult.organizationName){
                    <!-- Organization Info -->
                    <div class="surface-ground p-3 border-round mb-4">
                        <ul class="list-none p-0 m-0">
                            <li class="flex align-items-center justify-content-between mb-3 gap-3">
                                <span class="text-900 font-medium">Organization</span>
                                <span class="text-600 white-space-nowrap overflow-hidden text-overflow-ellipsis" style="max-width: 150px;" [title]="acceptResult.organizationName">{{ acceptResult.organizationName }}</span>
                            </li>
                            <li class="flex align-items-center justify-content-between mb-3">
                                <span class="text-900 font-medium">Role</span>
                                <span class="text-600">{{ acceptResult.role }}</span>
                            </li>
                            <li class="flex align-items-center justify-content-between">
                                <span class="text-900 font-medium">Status</span>
                                <span class="text-600">{{ acceptResult.status }}</span>
                            </li>
                        </ul>
                    </div>

                }

                @if(attemptedPostRegister){
                    <div class="flex flex-column gap-2">
                        <p-button label="Log In" severity="primary" icon="pi pi-sign-in" class="p-fluid" (click)="goToLogin()"></p-button>
                    </div>
                }
                @else{
                    <div class="flex justify-content-center gap-3">
                        <p-button
                            label="Stay in Current Organization"
                            icon="pi pi-check-circle"
                            severity="primary"
                            (click)="stayLoggedIn()">
                        </p-button>

                        <span class="my-auto">OR</span>

                        <p-button
                            label="Switch to {{ acceptResult.organizationName }}"
                            icon="pi pi-sync"
                            [outlined]="true"
                            severity="contrast"
                            (click)="switchOrgs()">
                        </p-button>
                    </div>
                }
            </div>
        }


        @if(error){
            <!-- Error State -->
            <div class="error-section">
                <div class="flex flex-column align-items-center mb-4">
                    <div class="border-circle bg-red-100 flex align-items-center justify-content-center" style="width: 3rem; height: 3rem">
                        <i class="pi pi-times text-red-500 text-2xl"></i>
                    </div>
                    <span class="text-red-500 font-bold text-xl mt-3">{{ errorStatus }}</span>
                    <p class="text-red-500 text-center mt-2">{{ error }}</p>
                </div>

                @if(showLogOrRegButton){
                    <div class="flex justify-content-center gap-3">
                        <p-button
                            label="Log In"
                            icon="pi pi-sign-in"
                            severity="primary"
                            (click)="goToLoginWithToken()">
                        </p-button>

                        <span class="my-auto">OR</span>

                        <p-button
                            label="Register"
                            icon="pi pi-user-plus"
                            [outlined]="true"
                            severity="contrast"
                            (click)="goToRegister()">
                        </p-button>
                    </div>
                }

                @if(!showLogOrRegButton){
                    <div class="text-center mt-4">
                        <p class="text-700 line-height-3 m-0">If you continue to have issues, please ask your organization admin to resend the invitation.</p>
                    </div>
                }
            </div>
        }

        @if(!token && !isLoading && !acceptResult && !error){
            <!-- No Token State -->
            <div class="flex flex-column align-items-center py-5">
                <div class="border-circle bg-yellow-100 flex align-items-center justify-content-center" style="width: 3rem; height: 3rem">
                    <i class="pi pi-exclamation-triangle text-yellow-500 text-2xl"></i>
                </div>
                <span class="text-900 font-bold text-xl mt-3">Invalid Link</span>
                <p class="text-600 mt-2">No token present in the URL.</p>
            </div>
        }

    </div>
</div>
